import React, { useState } from 'react';

import { useAppDispatch, useAppSelector } from 'state/hooks';
import {
  selectLegendSettings,
  updateLegendSettingsGlobal,
} from 'state/workflowSlice';

import { LegendSettings } from 'appTypes';
import { LegendSettingsModal } from 'features/map/LegendSettingsModal';
import { MapMetricLegend } from 'features/map/MapMetricLegend';

import { IMetricLegendConfig } from './metricsOptions';

export function TimelineLegend({
  hourlyMaxCount,
  metricsOptions,
}: {
  hourlyMaxCount: number;
  metricsOptions: IMetricLegendConfig;
}) {
  const legendSettings = useAppSelector(selectLegendSettings);
  const [showSettings, setShowSettings] = useState(false);
  const dispatch = useAppDispatch();

  if (!metricsOptions) {
    return null;
  }
  const selectedType = metricsOptions.color_schemes[legendSettings.type];
  const selectedColors = selectedType[legendSettings.scheme];

  const handleLegendSettingsChange = (legendSettings: LegendSettings) => {
    dispatch(updateLegendSettingsGlobal(legendSettings));
  };

  return (
    <>
      <MapMetricLegend
        colors={selectedColors}
        stops={metricsOptions.legend_stops}
        displayVolumeThickness={metricsOptions.display_volume_thickness ?? true}
        setShowSettings={setShowSettings}
        legendType={legendSettings.type}
      />
      <LegendSettingsModal
        initLegendSettings={legendSettings}
        metricSettings={metricsOptions}
        showSettings={showSettings}
        setShowSettings={setShowSettings}
        updateLegendSettings={handleLegendSettingsChange}
      />
    </>
  );
}
